module.exports = __webpack_public_path__ + "img/sw_wechat.5125767e.jpg";